module.exports = __webpack_public_path__ + "static/img/AnAnthologyFundraisingConcert-Jan8-1962.7d8228e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/AnAnthologyFundraisingConcert-Jan8-1962.jpg
// module id = 6fvF
// module chunks = 0